module.exports = __webpack_public_path__ + "img/welcome_1.c5edd72b.jpg";